module.exports = "<template> <div> <p if.bind=\"value !== null\" innerhtml.bind=\"value | json\"></p> </div> </template> ";